// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ArticleAuthor } from '../../ArticleAuthor';
import { ActionButton } from '../../ActionButton';
let ArticleAuthorBlock = class ArticleAuthorBlock extends Vue {
};
__decorate([
    Prop({ type: Object, required: false, default: null })
], ArticleAuthorBlock.prototype, "pdfAction", void 0);
__decorate([
    Prop({ type: Object, required: true })
], ArticleAuthorBlock.prototype, "author", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthorBlock.prototype, "isLazy", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthorBlock.prototype, "isMobile", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthorBlock.prototype, "hideDate", void 0);
__decorate([
    Prop({ type: String, required: false, default: false })
], ArticleAuthorBlock.prototype, "publicationDate", void 0);
__decorate([
    Prop({ type: Number, required: false, default: null })
], ArticleAuthorBlock.prototype, "readingTime", void 0);
ArticleAuthorBlock = __decorate([
    Component({
        name: 'ArticleAuthorBlock',
        components: {
            ActionButton,
            ArticleAuthor
        },
        template: `
    <ArticleAuthor
      :publicationDate="publicationDate"
      :readingTime="readingTime"
      :hideDate="hideDate"
      :author="author"
      :showInitialsWhenNoAvatar="true"
      :showReadingTime="true"
      :isMobile="isMobile"
    >
      <ActionButton v-if="pdfAction" class="d-md-none" v-bind="pdfAction" />
    </ArticleAuthor>
  `
    })
], ArticleAuthorBlock);
export { ArticleAuthorBlock };
